import React, { useState, useEffect } from 'react';
import apiService from '../../services/api';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTrash2, FiAlertCircle, FiUser } = FiIcons;

const ManageBugReports = () => {
  const [reports, setReports] = useState([]);
  const [users, setUsers] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [reportsResponse, usersResponse] = await Promise.all([
        apiService.getBugReports(),
        apiService.getUsers()
      ]);

      if (usersResponse.status === 'success') {
        const userMap = {};
        usersResponse.data.forEach(user => {
          userMap[user.id] = `${user.firstname} ${user.lastname} (${user.mail})`;
        });
        setUsers(userMap);
      }

      if (reportsResponse.status === 'success') {
        setReports(reportsResponse.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Möchten Sie diesen Bug Report wirklich löschen?')) {
      try {
        await apiService.deleteBugReport(id);
        fetchData();
      } catch (error) {
        console.error('Error deleting bug report:', error);
        alert('Fehler beim Löschen des Bug Reports');
      }
    }
  };

  if (loading) return (
    <div className="flex justify-center items-center py-12">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-primary"></div>
    </div>
  );

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-semibold text-brand-dark flex items-center">
          <SafeIcon icon={FiAlertCircle} className="mr-2" />
          Bug Reports
        </h2>
      </div>

      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <ul className="divide-y divide-gray-200">
          {reports.length > 0 ? (
            reports.map((report) => (
              <li key={report.id} className="px-6 py-4 hover:bg-gray-50">
                <div className="flex items-start justify-between">
                  <div className="flex-1 min-w-0 pr-4">
                    <div className="flex items-center text-sm text-gray-500 mb-2">
                      <SafeIcon icon={FiUser} className="flex-shrink-0 mr-1.5 h-4 w-4 text-gray-400" />
                      <span>{users[report.user] || `User ID: ${report.user}`}</span>
                    </div>
                    <p className="text-sm font-medium text-gray-900 whitespace-pre-wrap">
                      {report.bug_report}
                    </p>
                  </div>
                  <div className="ml-4 flex-shrink-0">
                    <button
                      onClick={() => handleDelete(report.id)}
                      className="text-red-600 hover:text-red-900 p-2 rounded-md hover:bg-red-50 transition-colors"
                      title="Löschen"
                    >
                      <SafeIcon icon={FiTrash2} className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <li className="px-6 py-12 text-center text-gray-500">
              <SafeIcon icon={FiAlertCircle} className="mx-auto h-12 w-12 text-gray-300 mb-3" />
              <p>Keine Bug Reports vorhanden</p>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default ManageBugReports;